import { Button, Upload } from "antd"
import UploadIcon from "../../../components/icons/UploadIcon"
import { DATE_FORMAT_DD_MM_YYYY, STATUS_REQUESTED, STATUS_UPLOADED, TODO_STATUS_COMPLETED, TODO_STATUS_PENDING } from "../../../constants/constants";
import UploadSuccessIcon from "../../../components/icons/UploadSuccessIcon";
import dayjs from "dayjs";
import { useState } from "react";

interface Props {
    data?: any
    onUpload: (data: any, file: any) => Promise<any>;
}
const TaskItem = (props: Props) => {
    const { data } = props;

    const [loading, setLoading] = useState(false);
    const onUploadFile = (data: any, file: any) => {
        setLoading(true);
        props?.onUpload(data, file)?.then((res: any) => {
            setLoading(false);

        }).catch((err) => {
            setLoading(false);

        })
    }

    return (
        <div className="flex p-[12px] gap-x-[10px] rounded-[8px] border border-[#E4E7EC]">
            {data?.status === TODO_STATUS_COMPLETED ? <UploadSuccessIcon /> : <UploadIcon />}
            <div className="flex-1">
                <p className="text-[13px] font-medium mb-[4px]">{data?.Brand?.brand_name ? `${data?.Brand?.brand_name} - ` : ""} {data?.sub_title}</p>
                <p className="text-[#475467] text-[12px] m-0">
                    {data?.completed_at ? `Completed - ${dayjs(data?.completed_at)?.format(DATE_FORMAT_DD_MM_YYYY)}` : data?.message}
                </p>
            </div>
            {data?.status === TODO_STATUS_PENDING ? (
                <Upload
                    className="upload-form-item"
                    onChange={(e: any) => onUploadFile(data, e?.file)}
                    beforeUpload={(file) => {
                        return false
                    }}
                    showUploadList={false}
                >
                    <Button type="primary" loading={loading} className="text-[12px] leading-[12px]" onClick={(e) => e.preventDefault()}>Upload</Button>
                </Upload>
            ) : (
                <></>
            )}

        </div>
    )
}

export default TaskItem